import * as React from 'react';

function SvgNotificationFilled(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.328 17.568C17.515 18.22 19 18.663 19 14.791 19 9.167 14.5 3 12 3S5 9.167 5 14.791c0 3.872 1.485 3.43 3.672 2.777.99-.295 2.123-.633 3.328-.633 1.205 0 2.338.338 3.328.633z"
        fill="currentColor"
      />
      <path
        d="M12 20.5c1.105 0 2-1 2-1.5 0-1.105-.895-1.5-2-1.5-1.104 0-2 .395-2 1.5 0 .5.895 1.5 2 1.5z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgNotificationFilled;
